import { render, staticRenderFns } from "./edit-menu.vue?vue&type=template&id=fbda0e14&scoped=true&"
import script from "./edit-menu.vue?vue&type=script&lang=js&"
export * from "./edit-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbda0e14",
  null
  
)

export default component.exports